import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsComponent } from './nps.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatStepperModule} from '@angular/material/stepper';
import {MatSelectModule} from '@angular/material/select';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseSidebarModule,FuseWidgetModule } from '@fuse/components';

import { TranslateModule } from '@ngx-translate/core';
import {MatExpansionModule} from '@angular/material/expansion';

import { NativeComponent } from './native/native.component';
import { PreviewComponent } from './preview/preview.component';
import { TraduccionesComponent } from './traducciones/traducciones.component';

const rutas: Routes = [
  {
    path: 'nps',
    component: NpsComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [NpsComponent, NativeComponent, PreviewComponent, TraduccionesComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    MatExpansionModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatStepperModule,
    FuseSharedModule,
    FuseConfirmDialogModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatSelectModule
  ]
})
export class NpsModuleMedir { }
